import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { BrainIcon, ZapIcon, ShieldIcon, SunIcon, EyeIcon, HeartIcon } from 'lucide-react';
export function BenefitsSection() {
  return <SectionWrapper id="beneficios" withGlow glowPosition="top" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <p className="text-[#c9a84c] text-sm font-semibold tracking-[0.2em] uppercase mb-6" data-id="element-4">
            Tu transformación
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8e6e1] mb-6 leading-tight" data-id="element-5">
            Lo que experimentarás en{' '}
            <span className="text-gold-gradient" data-id="element-6">21 días</span>
          </h2>
          <p className="text-lg text-[#9a9aab] max-w-2xl mx-auto" data-id="element-7">
            No es teoría. Es un cambio que se siente en cada área de tu vida.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-8">
          <div className="group p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50 transition-colors duration-300" data-id="element-9">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center mb-5" data-id="element-10">
              <BrainIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-11" />
            </div>
            <h3 className="text-[#e8e6e1] font-semibold text-lg mb-2" data-id="element-12">
              Claridad Mental Total
            </h3>
            <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-13">
              El ruido mental desaparece. Piensas con precisión. Tomas
              decisiones con seguridad y sin parálisis.
            </p>
          </div>

          <div className="group p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50 transition-colors duration-300" data-id="element-14">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center mb-5" data-id="element-15">
              <ZapIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-16" />
            </div>
            <h3 className="text-[#e8e6e1] font-semibold text-lg mb-2" data-id="element-17">
              Ejecución Sin Resistencia
            </h3>
            <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-18">
              Dejas de procrastinar. Actúas con naturalidad porque tu identidad
              ahora está alineada con tus metas.
            </p>
          </div>

          <div className="group p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50 transition-colors duration-300" data-id="element-19">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center mb-5" data-id="element-20">
              <ShieldIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-21" />
            </div>
            <h3 className="text-[#e8e6e1] font-semibold text-lg mb-2" data-id="element-22">
              Disciplina de Identidad
            </h3>
            <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-23">
              No necesitas fuerza de voluntad. La disciplina se convierte en
              parte de quién eres, no algo que "intentas hacer".
            </p>
          </div>

          <div className="group p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50 transition-colors duration-300" data-id="element-24">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center mb-5" data-id="element-25">
              <SunIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-26" />
            </div>
            <h3 className="text-[#e8e6e1] font-semibold text-lg mb-2" data-id="element-27">
              Estabilidad Espiritual
            </h3>
            <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-28">
              Sientes paz interior genuina. Una conexión profunda contigo mismo
              que no depende de circunstancias externas.
            </p>
          </div>

          <div className="group p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50 transition-colors duration-300" data-id="element-29">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center mb-5" data-id="element-30">
              <EyeIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-31" />
            </div>
            <h3 className="text-[#e8e6e1] font-semibold text-lg mb-2" data-id="element-32">
              Control Sobre Tu Mente
            </h3>
            <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-33">
              Tú decides qué pensamientos alimentas. La ansiedad y el ruido
              mental dejan de controlarte.
            </p>
          </div>

          <div className="group p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50 transition-colors duration-300" data-id="element-34">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center mb-5" data-id="element-35">
              <HeartIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-36" />
            </div>
            <h3 className="text-[#e8e6e1] font-semibold text-lg mb-2" data-id="element-37">
              Propósito Claro
            </h3>
            <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-38">
              Despiertas cada día sabiendo exactamente por qué y para qué. Sin
              vacío existencial. Sin dudas.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}